import request from '../wrappers/axios';
import config from '../../config/config';

class CodeBlockService {

  getCodeBlockList(query , extendedQuery = ''){
    return request({
      url: `${config.API.BASEURL}/codeBlock${extendedQuery}`,
      method: 'get',
      params: query
    });
  }

  newCodeBlock (data) {
    return request({
      url: `${config.API.BASEURL}/codeBlock`,
      method: 'post',
      data: data
    }, true, 500);
  }

  updateCodeBlock (data) {
    return request({
      url: `${config.API.BASEURL}/codeBlock/${data._id}`,
      method: 'put',
      data: data
    }, true, 500);
  }

  getCodeBlock (codeBlockId) {
    return request({
      url: `${config.API.BASEURL}/codeBlock/${codeBlockId}`,
      method: 'get'
    });
  }
}

export default new CodeBlockService();